import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import ReportSettingsFormV1 from '../app-form/ReportSettingsFormV1'
import Wrapper from '../wrapper'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'

const styles = theme => ({
  appBar: {
    backgroundColor: '#8866FF',
  },
  paper: {
    backgroundColor: '#8866FF',
  },
})

function Transition(props) {
  return <Slide direction="down" {...props} />
}

class PopupSettings extends Component {
  state = {
    open: this.props.isOpen,
    isFetching: this.props.isFetching,
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        open: this.props.isOpen,
      })
    }
    if (prevProps.isFetching !== this.props.isFetching) {
      this.setState({
        isFetching: this.props.isFetching,
      })
    }
  }

  render() {
    const { classes, submit, close, goals, leads, orders } = this.props
    const { isFetching, open } = this.state

    return (
      <Dialog
        fullScreen
        open={open}
        TransitionComponent={Transition}
        PaperProps={{
          classes: {
            root: this.props.classes.paper,
          },
        }}
      >
        <AppBar className={classes.appBar} elevation={0} position="static">
          <Toolbar style={{ paddingTop: 16 }}>
            <IconButton
              color="inherit"
              onClick={close}
              aria-label="Close"
              style={{ marginLeft: 'auto' }}
            >
              <CloseIcon style={{ fill: '#fff' }} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div
          style={{
            maxWidth: 440,
            width: '100%',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <header
            style={{
              marginBottom: '5px',
            }}
          >
            <h6
              style={{
                fontFamily: 'Roboto',
                fontSize: 24,
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#fff',
                margin: '0 0 24px 0',
              }}
            >
              Настройки дашборда
            </h6>
          </header>
          <Wrapper
            shadow={1}
            style={{
              width: '100%',
              borderRadius: 8,
              overflow: 'hidden',
              padding: '40px 50px 50px 50px',
              backgroundColor: 'rgb(255,255,255)',
              fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
              lineHeight: 1.5,
            }}
          >
            <ReportSettingsFormV1
              goals={goals}
              onSubmit={submit}
              isFetching={isFetching}
              initialValues={{
                leads,
                orders,
              }}
            />
          </Wrapper>
        </div>
      </Dialog>
    )
  }
}

export default withStyles(styles)(PopupSettings)
